var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayer5Winter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3001 844",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer-5",
    serifId: "layer 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "house"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2868.14,75.631c-0.318,-1.179 -1.387,-1.998 -2.608,-1.998c-1.221,0 -2.291,0.819 -2.609,1.998c-5.239,19.068 -16.549,62.72 -16.549,84.282c0,17.42 8.585,31.562 19.158,31.562c10.573,0 19.157,-14.142 19.157,-31.562c-0,-21.562 -11.309,-65.214 -16.549,-84.282Z",
    style: {
      fill: "#8ecbd2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2837.22,60.637c-0.388,-1.255 -1.548,-2.111 -2.861,-2.111c-1.314,-0.001 -2.474,0.855 -2.861,2.11c-6.411,20.489 -21.371,70.937 -21.371,95.574c0,19.464 10.858,35.265 24.232,35.265c13.374,0 24.232,-15.801 24.232,-35.265c-0,-24.637 -14.96,-75.085 -21.371,-95.573Z",
    style: {
      fill: "#8ecbd2"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2711.78,146.594c-0,-1.745 -1.414,-3.159 -3.159,-3.159c0,0 -0,0 -0,0c-1.745,0 -3.159,1.414 -3.159,3.159l0,56.008l6.318,0l-0,-56.008Z",
    style: {
      fill: "#383128"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2711.78,146.594c-0,-1.745 -1.414,-3.159 -3.159,-3.159c0,0 -0,0 -0,0c-1.745,0 -3.159,1.414 -3.159,3.159l0,56.008l6.318,0l-0,-56.008Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2705.46,
    y: 137.118,
    width: 6.317,
    height: 15.794,
    style: {
      fill: "#06dbff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2746.44,146.203l19.589,-43.432l56.699,43.64l-0.473,48.941l-75.771,-0l-0.044,-49.149Z",
    style: {
      fill: "#ffebba"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2746.44,146.203l19.589,-43.432l56.699,43.64l-0.473,48.941l-75.771,-0l-0.044,-49.149Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2749.85,147.254c-0,-0.182 0.035,-0.363 0.104,-0.531c1.35,-3.317 15.397,-37.826 15.397,-37.826c0,0 13.67,34.548 14.97,37.831c0.065,0.165 0.098,0.341 0.098,0.519c0,3.2 0,34.05 0,41.052c0,0.778 -0.63,1.409 -1.409,1.409c-5.11,0 -22.641,0 -27.751,0c-0.778,0 -1.409,-0.631 -1.409,-1.409c-0,-6.997 -0,-37.806 -0,-41.045Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.86
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2766.12,122.207c-0.142,-0.425 -0.539,-0.712 -0.987,-0.712c-0.448,0 -0.846,0.287 -0.988,0.712c-1.339,4.018 -3.708,11.124 -4.956,14.867c-0.19,0.572 -0.094,1.2 0.258,1.688c0.352,0.489 0.917,0.778 1.52,0.778c2.396,0 5.935,0 8.332,0c0.602,0 1.167,-0.289 1.519,-0.778c0.352,-0.488 0.448,-1.116 0.258,-1.688c-1.248,-3.743 -3.617,-10.849 -4.956,-14.867Z",
    style: {
      fill: "#ffa35f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2763.88,95.18c-0.749,0.003 -1.426,0.444 -1.732,1.128c-2.84,6.366 -16.939,37.961 -21.16,47.422c-0.263,0.589 -0.21,1.272 0.141,1.813c0.352,0.541 0.953,0.868 1.598,0.868c0.913,0 1.869,0 2.599,0c0.752,0 1.433,-0.442 1.739,-1.129c3.055,-6.845 18.97,-42.511 18.97,-42.511c-0,-0 14.891,33.373 18.63,41.75c0.513,1.15 1.654,1.89 2.912,1.89c6.717,0 28.033,0 37.753,0c1.081,0 2.088,-0.547 2.676,-1.453c0.588,-0.907 0.677,-2.049 0.237,-3.036c-4.799,-10.755 -16.8,-37.649 -20.092,-45.028c-0.515,-1.154 -1.663,-1.895 -2.927,-1.89c-7.801,0.033 -35.198,0.149 -41.344,0.176Z",
    style: {
      fill: "#4eb2b7"
    }
  }), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2763.88,95.18c-0.749,0.003 -1.426,0.444 -1.732,1.128c-2.84,6.366 -16.939,37.961 -21.16,47.422c-0.263,0.589 -0.21,1.272 0.141,1.813c0.352,0.541 0.953,0.868 1.598,0.868c0.913,0 1.869,0 2.599,0c0.752,0 1.433,-0.442 1.739,-1.129c3.055,-6.845 18.97,-42.511 18.97,-42.511c-0,-0 14.891,33.373 18.63,41.75c0.513,1.15 1.654,1.89 2.912,1.89c6.717,0 28.033,0 37.753,0c1.081,0 2.088,-0.547 2.676,-1.453c0.588,-0.907 0.677,-2.049 0.237,-3.036c-4.799,-10.755 -16.8,-37.649 -20.092,-45.028c-0.515,-1.154 -1.663,-1.895 -2.927,-1.89c-7.801,0.033 -35.198,0.149 -41.344,0.176Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2758.65,98.547c2.527,-0.761 5.383,-1.388 8.024,-1.142c10.44,0.971 11.674,15.66 21.148,18.516c5.991,1.806 10.031,-7.253 15.923,-4.241c2.258,1.154 3.774,3.758 5.098,5.811c1.769,2.741 3.906,5.641 6.607,7.526c2.71,1.892 6.628,1.201 7.98,-1.953c1.109,-2.586 0.814,-6.079 0.62,-8.812c-0.632,-8.911 -3.768,-16.802 -11.799,-21.556c-5.025,-2.975 -11.038,-3.955 -16.751,-4.636c-11.938,-1.423 -26.127,-2.133 -36.01,5.759",
    style: {
      fill: "#fff",
      fillOpacity: 0.77
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2775.61,78.953c0.645,1.078 1.809,1.739 3.065,1.739c1.257,-0 2.421,-0.661 3.066,-1.739c5.196,-8.293 15.178,-25.338 15.178,-33.92c-0,-9.701 -8.175,-17.578 -18.244,-17.578c-10.068,0 -18.243,7.877 -18.243,17.578c0,8.582 9.982,25.627 15.178,33.92Z",
    style: {
      fill: "#4eb2b7"
    }
  }), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2775.61,78.953c0.645,1.078 1.809,1.739 3.065,1.739c1.257,-0 2.421,-0.661 3.066,-1.739c5.196,-8.293 15.178,-25.338 15.178,-33.92c-0,-9.701 -8.175,-17.578 -18.244,-17.578c-10.068,0 -18.243,7.877 -18.243,17.578c0,8.582 9.982,25.627 15.178,33.92Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2770.69,40.667c-1.939,1.939 -1.939,5.083 0,7.023c1.94,1.939 5.084,1.939 7.024,-0l3.458,-3.459c0.353,-0.353 0.924,-0.353 1.277,0c0.352,0.353 0.352,0.925 0,1.278l-2.486,2.486c1.951,1.629 4.858,1.527 6.689,-0.305c1.94,-1.94 1.94,-5.084 0,-7.023c-1.939,-1.94 -5.083,-1.94 -7.023,-0l-3.459,3.458c-0.352,0.352 -0.924,0.352 -1.277,0c-0.352,-0.353 -0.352,-0.924 0,-1.277l2.487,-2.487c-1.951,-1.628 -4.858,-1.526 -6.69,0.306Zm7.982,-1.577c-2.66,-2.341 -6.718,-2.241 -9.259,0.299c-2.644,2.645 -2.644,6.933 0,9.578c2.541,2.54 6.599,2.64 9.259,0.299c2.66,2.341 6.717,2.241 9.257,-0.299c2.645,-2.645 2.645,-6.933 0,-9.578c-2.54,-2.54 -6.597,-2.64 -9.257,-0.299Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "house-and-car-3",
    serifId: "house and car 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M672.844,301.217c17.949,1.85 17.042,-31.74 -4.372,-35.366c-13.73,-2.325 -13.301,5.964 -21.648,5.546c-10.701,-0.537 -4.466,-19.637 -25.472,-21.172c-23.927,-1.748 -33.239,29.115 -24.34,40.816c4.823,6.34 7.882,14.936 14.736,15.862c8.233,1.114 16.51,1.908 24.718,3.189c13.437,2.096 14.623,-11.117 36.378,-8.875Z",
    style: {
      fill: "#8ecbd2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.718,194.792c0,-0 1.782,-59.651 1.631,-89.548c-0.047,-9.297 -0.758,-20.67 -10.974,-25.184c-1.511,-0.668 -3.148,-1.07 -4.803,-1.088c-5.333,-0.061 -10.415,2.258 -15.815,1.891c-3.879,-0.264 -14.762,-0.187 -12.046,-7.092c2.836,-7.209 12.624,-2.752 17.93,-3.952c7.803,-1.764 12.282,-10.972 20.913,-11.113c4.449,-0.073 6.36,3.248 9.575,5.55c2.683,1.922 6.01,2.404 9.23,1.99c9.377,-1.204 16.74,-10.945 27.001,-5.763c5.076,2.563 8.143,8.14 13.062,11.098c1.59,0.957 3.393,1.319 5.217,1.481c1.773,0.157 3.548,0.169 5.324,0.245c4.147,0.179 18.18,5.277 10.509,10.737c-3.302,2.351 -8.366,2.118 -12.19,2.405c-4.199,0.315 -8.612,-0.616 -12.756,-1.164c-3.579,-0.473 -7.04,-0.69 -10.603,0.071c-12.468,2.663 -20.998,17.501 -29.699,25.187c-4.361,3.852 -3.793,25.375 -3.782,38.297c0.013,15.144 0.132,30.292 0.78,45.425c0,-0 -8.504,0.527 -8.504,0.527Zm36.978,-112.405c0.521,0.22 -3.053,3.449 -4.98,4.32c-5.833,2.635 -7.997,5.098 -12.828,10.957c-2.034,2.467 -10.44,11.425 -10.882,11.398c-0.295,-0.018 0.368,-5.697 0.393,-8.3c0.061,-6.484 -1.475,-16.985 -0.19,-18.427c1.971,-2.212 10.854,3.059 17.071,1.932c5.57,-1.01 5.159,-4.529 11.416,-1.88Z",
    style: {
      fill: "#8ecbd2"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M273.159,98.487c4.339,2.292 6.043,7.597 3.802,11.838c-2.241,4.242 -7.583,5.825 -11.922,3.532c-4.34,-2.292 -6.043,-7.597 -3.803,-11.838c2.241,-4.242 7.583,-5.825 11.923,-3.532Z",
    style: {
      fill: "#ffa35f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.487,133.622c4.823,2.548 6.717,8.444 4.227,13.159c-2.491,4.715 -8.429,6.474 -13.252,3.926c-4.824,-2.548 -6.717,-8.445 -4.227,-13.159c2.491,-4.715 8.429,-6.474 13.252,-3.926Z",
    style: {
      fill: "#ffa35f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.027,160.901c-0.861,1.564 -2.316,2.715 -4.037,3.192c-1.72,0.476 -3.561,0.239 -5.104,-0.659c-19.848,-11.553 -83.545,-48.63 -89.083,-51.854c-0.257,-0.149 -0.51,-0.305 -0.759,-0.467c-1.233,-0.806 -5.319,-3.474 -9.204,-6.011c-1.754,-1.146 -2.804,-3.106 -2.784,-5.201c0.02,-2.094 1.106,-4.035 2.882,-5.147c0,-0 0.001,-0.001 0.002,-0.001c5.298,-3.318 11.735,-4.288 17.775,-2.679c7.667,2.042 17.67,4.707 20.668,5.505c0.588,0.157 1.195,0.232 1.804,0.223c1.774,-0.026 5.904,-0.087 10.438,-0.154c11.18,-0.164 22.21,2.583 32.007,7.97c0.001,0 0.001,0.001 0.001,0.001c8.837,4.859 16.333,11.831 21.819,20.292c3.618,5.581 7.574,11.683 10.009,15.439c1.44,2.221 1.542,5.055 0.266,7.374c-1.842,3.347 -4.564,8.296 -6.7,12.177Z",
    style: {
      fill: "#ffebba"
    }
  }), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.027,160.901c-0.861,1.564 -2.316,2.715 -4.037,3.192c-1.72,0.476 -3.561,0.239 -5.104,-0.659c-19.848,-11.553 -83.545,-48.63 -89.083,-51.854c-0.257,-0.149 -0.51,-0.305 -0.759,-0.467c-1.233,-0.806 -5.319,-3.474 -9.204,-6.011c-1.754,-1.146 -2.804,-3.106 -2.784,-5.201c0.02,-2.094 1.106,-4.035 2.882,-5.147c0,-0 0.001,-0.001 0.002,-0.001c5.298,-3.318 11.735,-4.288 17.775,-2.679c7.667,2.042 17.67,4.707 20.668,5.505c0.588,0.157 1.195,0.232 1.804,0.223c1.774,-0.026 5.904,-0.087 10.438,-0.154c11.18,-0.164 22.21,2.583 32.007,7.97c0.001,0 0.001,0.001 0.001,0.001c8.837,4.859 16.333,11.831 21.819,20.292c3.618,5.581 7.574,11.683 10.009,15.439c1.44,2.221 1.542,5.055 0.266,7.374c-1.842,3.347 -4.564,8.296 -6.7,12.177Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.682,143.576c4.859,4.745 5.037,12.454 0.399,17.203c-4.639,4.749 -12.349,4.752 -17.208,0.007c-4.858,-4.745 -5.037,-12.454 -0.399,-17.203c4.639,-4.749 12.349,-4.752 17.208,-0.007Z",
    style: {
      fill: "#ffbd58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.16,109.6c4.859,4.746 5.038,12.454 0.399,17.203c-4.638,4.75 -12.349,4.753 -17.208,0.008c-4.858,-4.746 -5.037,-12.454 -0.399,-17.203c4.639,-4.75 12.349,-4.753 17.208,-0.008Z",
    style: {
      fill: "#ffbd58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.66,98.609c-0.126,0.139 -0.188,0.324 -0.171,0.51c0.018,0.186 0.112,0.357 0.261,0.47c1.581,1.199 6.035,4.579 8.887,6.742c1.546,1.173 3.619,1.383 5.369,0.543c1.668,-0.801 3.819,-1.834 5.748,-2.76c3.186,-1.529 6.717,-2.198 10.241,-1.939c1.778,0.131 3.799,0.28 5.739,0.422c0.57,0.042 1.084,-0.342 1.204,-0.901c0.121,-0.559 -0.189,-1.122 -0.726,-1.318c-0.324,-0.119 -0.571,-0.209 -0.71,-0.26c-0.085,-0.031 -0.171,-0.058 -0.258,-0.081c-1.37,-0.357 -13.184,-3.436 -21.523,-5.61c-5.099,-1.329 -10.515,0.282 -14.06,4.181c-0,0 -0.001,0.001 -0.001,0.001Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.86
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M314.348,107.829c-0.149,-0.086 -0.235,-0.25 -0.222,-0.421c0.014,-0.172 0.125,-0.32 0.286,-0.381c0.771,-0.295 1.992,-0.76 3.416,-1.303c7.479,-2.851 15.892,-1.72 22.352,3.005c0.001,0 0.001,0.001 0.002,0.001c6.091,4.455 11.446,9.839 15.868,15.955c0.803,1.111 1.623,2.245 2.424,3.353c0.654,0.904 0.587,2.142 -0.16,2.971c-0.748,0.829 -1.973,1.023 -2.94,0.466c-13.344,-7.691 -36.421,-20.992 -41.026,-23.646Z",
    style: {
      fill: "#4eb2b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.367,101.812c0.269,-0.09 0.445,-0.349 0.43,-0.632c-0.015,-0.283 -0.217,-0.522 -0.494,-0.583c-6.234,-1.319 -13.073,-1.658 -18.483,-0.732c-0.25,0.048 -0.447,0.243 -0.498,0.492c-0.051,0.25 0.054,0.506 0.265,0.648c1.999,1.351 5.788,3.909 6.81,4.599c0.163,0.11 0.369,0.138 0.556,0.075c1.465,-0.497 7.999,-2.71 11.414,-3.867Z",
    style: {
      fill: "#4eb2b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.268,109.663c4.824,2.548 6.718,8.444 4.227,13.159c-2.491,4.715 -8.429,6.474 -13.252,3.926c-4.823,-2.548 -6.717,-8.444 -4.227,-13.159c2.491,-4.715 8.429,-6.474 13.252,-3.926Z",
    style: {
      fill: "#4eb2b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.79,143.639c4.824,2.548 6.717,8.444 4.227,13.159c-2.491,4.714 -8.429,6.473 -13.252,3.925c-4.823,-2.548 -6.717,-8.444 -4.227,-13.159c2.491,-4.714 8.429,-6.473 13.252,-3.925Z",
    style: {
      fill: "#4eb2b7"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M607.546,116.945l-19.204,-31.894l-53.919,32.124l2.537,170.296l72.627,-0l-2.041,-170.526Z",
    style: {
      fill: "#ffebba"
    }
  }), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M607.546,116.945l-19.204,-31.894l-53.919,32.124l2.537,170.296l72.627,-0l-2.041,-170.526Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M593.696,247.323c-0,-4.603 -3.731,-8.334 -8.333,-8.334c-0,0 -0,0 -0,0c-4.603,0 -8.334,3.731 -8.334,8.334c0,12.05 0,32.913 0,32.913l16.667,-0l-0,-32.913Z",
    style: {
      fill: "#4eb2b7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M590.303,85.173c1.167,0.003 2.25,0.608 2.864,1.6c3.426,5.533 14.825,23.946 19.196,31.006c0.357,0.577 0.381,1.301 0.061,1.9c-0.32,0.599 -0.934,0.982 -1.612,1.007c-0.792,0.028 -1.583,0.056 -2.188,0.078c-0.669,0.024 -1.302,-0.305 -1.667,-0.867c-3.163,-4.875 -18.022,-27.781 -18.022,-27.781c-0,-0 -13.927,21.228 -17.721,27.012c-0.589,0.898 -1.592,1.44 -2.667,1.44c-5.916,-0 -25.583,-0 -35.434,-0c-1.157,-0 -2.223,-0.627 -2.786,-1.638c-0.563,-1.01 -0.535,-2.247 0.074,-3.231c5.047,-8.15 14.955,-24.155 18.039,-29.136c0.583,-0.942 1.613,-1.514 2.721,-1.51c3.616,0.011 11.468,0.036 11.468,0.036l0,-11.455c0,-0.987 0.8,-1.787 1.787,-1.787c1.277,0 2.988,0 4.264,0c0.474,0 0.929,0.189 1.264,0.524c0.335,0.335 0.523,0.789 0.523,1.263c-0,3.62 -0,11.48 -0,11.48c-0,-0 14.565,0.043 19.836,0.059Z",
    style: {
      fill: "#4eb2b7"
    }
  }), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M590.303,85.173c1.167,0.003 2.25,0.608 2.864,1.6c3.426,5.533 14.825,23.946 19.196,31.006c0.357,0.577 0.381,1.301 0.061,1.9c-0.32,0.599 -0.934,0.982 -1.612,1.007c-0.792,0.028 -1.583,0.056 -2.188,0.078c-0.669,0.024 -1.302,-0.305 -1.667,-0.867c-3.163,-4.875 -18.022,-27.781 -18.022,-27.781c-0,-0 -13.927,21.228 -17.721,27.012c-0.589,0.898 -1.592,1.44 -2.667,1.44c-5.916,-0 -25.583,-0 -35.434,-0c-1.157,-0 -2.223,-0.627 -2.786,-1.638c-0.563,-1.01 -0.535,-2.247 0.074,-3.231c5.047,-8.15 14.955,-24.155 18.039,-29.136c0.583,-0.942 1.613,-1.514 2.721,-1.51c3.616,0.011 11.468,0.036 11.468,0.036l0,-11.455c0,-0.987 0.8,-1.787 1.787,-1.787c1.277,0 2.988,0 4.264,0c0.474,0 0.929,0.189 1.264,0.524c0.335,0.335 0.523,0.789 0.523,1.263c-0,3.62 -0,11.48 -0,11.48c-0,-0 14.565,0.043 19.836,0.059Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.803,102.623c0.447,1.579 1.129,2.93 2.227,4.004c7.257,7.097 14.027,-1.33 20.776,-4.032c3.181,-1.274 5.219,0.708 8.204,1.522c2.578,0.703 4.971,0.335 7.371,-0.887c4.454,-2.27 6.873,-7.929 10.602,-11.298c3.575,-3.231 8.518,-3.724 12.079,-6.787c2.752,-2.367 2.051,-6.494 -0.292,-8.872c-1.037,-1.053 -2.229,-2.044 -3.448,-2.792c-1.784,-1.095 -3.731,-1.68 -5.704,-2.093c-3.284,-0.689 -6.649,-0.921 -9.984,-0.875c-5.562,0.076 -11.335,1.083 -16.669,2.885c-10.238,3.459 -19.045,11.068 -23.306,22.732",
    style: {
      fill: "#fff",
      fillOpacity: 0.73
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M571.112,131.868c0.021,-0.951 -0.341,-1.871 -1.007,-2.552c-0.665,-0.68 -1.576,-1.064 -2.528,-1.064c-6.044,0 -18.123,0 -24.112,0c-1.953,0 -3.536,1.583 -3.536,3.536c0,8.789 0,31.273 0,36.148c0,0.617 0.162,1.224 0.469,1.759c2.53,4.414 14.74,25.709 22.4,39.07c0.789,1.377 2.4,2.059 3.938,1.668c1.538,-0.391 2.627,-1.759 2.663,-3.346c0.483,-21.207 1.429,-62.758 1.713,-75.219Z",
    style: {
      fill: "#fff8f5",
      fillOpacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M429.978,157.711c-0,-0.866 -0.345,-1.697 -0.957,-2.31c-0.613,-0.612 -1.444,-0.956 -2.31,-0.956c-0.002,-0 -0.004,-0 -0.007,-0c-0.866,-0 -1.697,0.344 -2.309,0.956c-0.613,0.613 -0.957,1.444 -0.957,2.31c-0,12.686 -0,57.984 -0,57.984l6.54,-0c-0,-0 -0,-45.298 -0,-57.984Z",
    style: {
      fill: "#383128"
    }
  }), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429.978,157.711c-0,-0.866 -0.345,-1.697 -0.957,-2.31c-0.613,-0.612 -1.444,-0.956 -2.31,-0.956c-0.002,-0 -0.004,-0 -0.007,-0c-0.866,-0 -1.697,0.344 -2.309,0.956c-0.613,0.613 -0.957,1.444 -0.957,2.31c-0,12.686 -0,57.984 -0,57.984l6.54,-0c-0,-0 -0,-45.298 -0,-57.984Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423.438,
    y: 147.905,
    width: 6.54,
    height: 16.35,
    style: {
      fill: "#20f58f"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M544.434,210.464l-22.837,-43.432l-66.102,43.64l0.552,69.564l88.336,-0l0.051,-69.772Z",
    style: {
      fill: "#ffebba"
    }
  }), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M544.434,210.464l-22.837,-43.432l-66.102,43.64l0.552,69.564l88.336,-0l0.051,-69.772Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M498.151,218.79c-0,-0.778 -0.631,-1.409 -1.409,-1.409c-5.712,0 -27.11,0 -32.822,0c-0.778,0 -1.409,0.631 -1.409,1.409c0,6.266 0,31.564 0,37.829c0,0.779 0.631,1.409 1.409,1.409c5.712,0 27.11,0 32.822,0c0.778,0 1.409,-0.63 1.409,-1.409c-0,-6.265 -0,-31.563 -0,-37.829Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M519.906,186.002c0.156,-0.4 0.541,-0.664 0.97,-0.664c0.43,0 0.815,0.264 0.97,0.664c1.51,3.883 4.404,11.33 5.926,15.247c0.224,0.576 0.149,1.226 -0.2,1.737c-0.349,0.51 -0.928,0.815 -1.546,0.815c-2.888,0 -7.411,0 -10.299,0c-0.618,0 -1.197,-0.305 -1.546,-0.815c-0.349,-0.511 -0.424,-1.161 -0.2,-1.737c1.522,-3.917 4.416,-11.364 5.925,-15.247Z",
    style: {
      fill: "#ffa35f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.392,159.442c0.708,0.002 1.356,0.397 1.683,1.025c3.174,6.101 19.656,37.784 24.67,47.421c0.307,0.591 0.283,1.299 -0.062,1.868c-0.345,0.569 -0.963,0.916 -1.628,0.916l-3.599,-0c-0.711,-0 -1.362,-0.395 -1.69,-1.026c-3.424,-6.582 -22.169,-42.614 -22.169,-42.614c0,-0 -17.605,33.842 -21.809,41.922c-0.549,1.056 -1.64,1.718 -2.829,1.718c-7.344,-0 -33.638,-0 -44.967,-0c-1.115,-0 -2.149,-0.582 -2.727,-1.535c-0.578,-0.952 -0.617,-2.138 -0.103,-3.126c5.699,-10.955 19.741,-37.948 23.425,-45.03c0.551,-1.059 1.648,-1.722 2.842,-1.717c8.501,0.03 42.282,0.153 48.963,0.178Z",
    style: {
      fill: "#4eb2b7"
    }
  }), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M524.392,159.442c0.708,0.002 1.356,0.397 1.683,1.025c3.174,6.101 19.656,37.784 24.67,47.421c0.307,0.591 0.283,1.299 -0.062,1.868c-0.345,0.569 -0.963,0.916 -1.628,0.916l-3.599,-0c-0.711,-0 -1.362,-0.395 -1.69,-1.026c-3.424,-6.582 -22.169,-42.614 -22.169,-42.614c0,-0 -17.605,33.842 -21.809,41.922c-0.549,1.056 -1.64,1.718 -2.829,1.718c-7.344,-0 -33.638,-0 -44.967,-0c-1.115,-0 -2.149,-0.582 -2.727,-1.535c-0.578,-0.952 -0.617,-2.138 -0.103,-3.126c5.699,-10.955 19.741,-37.948 23.425,-45.03c0.551,-1.059 1.648,-1.722 2.842,-1.717c8.501,0.03 42.282,0.153 48.963,0.178Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.546,175.215c0.482,1.464 1.216,2.715 2.398,3.71c7.813,6.574 15.102,-1.232 22.367,-3.735c3.425,-1.18 5.62,0.656 8.833,1.41c2.775,0.651 5.352,0.31 7.935,-0.822c4.796,-2.102 7.4,-7.345 11.414,-10.466c3.85,-2.993 9.171,-3.45 13.005,-6.287c2.963,-2.193 2.208,-6.016 -0.314,-8.219c-1.117,-0.975 -2.401,-1.894 -3.713,-2.586c-1.921,-1.014 -4.017,-1.556 -6.141,-1.939c-3.536,-0.638 -7.157,-0.853 -10.748,-0.811c-5.989,0.071 -12.204,1.004 -17.946,2.673c-11.022,3.204 -20.504,10.253 -25.092,21.058",
    style: {
      fill: "#fff",
      fillOpacity: 0.73
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M561.398,47.158c1.12,2.122 3.322,3.45 5.722,3.45c2.399,0 4.602,-1.327 5.722,-3.449c5.349,-8.952 12.521,-22.307 12.521,-29.581c-0,-9.702 -8.175,-17.578 -18.244,-17.578c-10.068,0 -18.243,7.876 -18.243,17.578c0,7.274 7.172,20.629 12.522,29.58Z",
    style: {
      fill: "#4eb2b7"
    }
  }), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561.398,47.158c1.12,2.122 3.322,3.45 5.722,3.45c2.399,0 4.602,-1.327 5.722,-3.449c5.349,-8.952 12.521,-22.307 12.521,-29.581c-0,-9.702 -8.175,-17.578 -18.244,-17.578c-10.068,0 -18.243,7.876 -18.243,17.578c0,7.274 7.172,20.629 12.522,29.58Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M559.138,13.212c-1.939,1.938 -1.939,5.083 0,7.023c1.94,1.939 5.084,1.939 7.024,-0l3.458,-3.459c0.353,-0.353 0.924,-0.353 1.277,0c0.353,0.353 0.353,0.924 0,1.278l-2.486,2.486c1.951,1.628 4.858,1.526 6.689,-0.305c1.94,-1.94 1.94,-5.085 0,-7.023c-1.939,-1.94 -5.083,-1.94 -7.023,-0l-3.458,3.458c-0.353,0.352 -0.924,0.352 -1.278,0c-0.352,-0.353 -0.352,-0.924 0,-1.277l2.487,-2.487c-1.951,-1.628 -4.858,-1.526 -6.69,0.306Zm7.982,-1.578c-2.66,-2.34 -6.717,-2.24 -9.259,0.3c-2.644,2.645 -2.644,6.933 0,9.578c2.542,2.54 6.599,2.64 9.259,0.299c2.66,2.341 6.717,2.241 9.258,-0.299c2.644,-2.645 2.644,-6.933 -0,-9.578c-2.541,-2.54 -6.598,-2.64 -9.258,-0.3Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M891.667,177.455l9.87,-4.167",
    style: {
      fill: "none",
      stroke: "#4eb2b7",
      strokeWidth: "2.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.431,174.975c-0,0 -1.417,24.219 4.106,24.162",
    style: {
      fill: "none",
      stroke: "#4eb2b7",
      strokeWidth: "2.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.936,226.607c-0.673,-0.001 -1.292,-0.368 -1.617,-0.958c-2.147,-3.837 -5.027,-8.627 -5.027,-13.819c0,-5.193 2.881,-9.984 5.027,-13.82c0.324,-0.589 0.944,-0.956 1.617,-0.956c3.774,-0.001 16.273,-0.001 20.046,-0.001c0.673,0.001 1.293,0.368 1.617,0.958c2.146,3.835 5.027,8.626 5.027,13.819c-0,5.192 -2.88,9.982 -5.027,13.819c-0.324,0.59 -0.944,0.956 -1.617,0.956c-3.774,0.002 -16.272,0.002 -20.046,0.002Z",
    style: {
      fill: "#4eb2b7"
    }
  }), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M888.936,226.607c-0.673,-0.001 -1.292,-0.368 -1.617,-0.958c-2.147,-3.837 -5.027,-8.627 -5.027,-13.819c0,-5.193 2.881,-9.984 5.027,-13.82c0.324,-0.589 0.944,-0.956 1.617,-0.956c3.774,-0.001 16.273,-0.001 20.046,-0.001c0.673,0.001 1.293,0.368 1.617,0.958c2.146,3.835 5.027,8.626 5.027,13.819c-0,5.192 -2.88,9.982 -5.027,13.819c-0.324,0.59 -0.944,0.956 -1.617,0.956c-3.774,0.002 -16.272,0.002 -20.046,0.002Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M897.397,201.584c-0,-0.67 -0.543,-1.212 -1.212,-1.212c-1.798,-0 -5.153,-0 -6.951,-0c-0.67,-0 -1.212,0.542 -1.212,1.212c-0,2.745 -0,9.413 -0,12.159c-0,0.669 0.542,1.212 1.212,1.212c1.798,0 5.153,0 6.951,0c0.669,0 1.212,-0.543 1.212,-1.212c-0,-2.746 -0,-9.414 -0,-12.159Z",
    style: {
      fill: "#94dadd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.897,201.584c-0,-0.67 -0.543,-1.212 -1.212,-1.212c-1.798,-0 -5.153,-0 -6.951,-0c-0.67,-0 -1.212,0.542 -1.212,1.212c-0,2.745 -0,9.413 -0,12.159c-0,0.669 0.542,1.212 1.212,1.212c1.798,0 5.153,0 6.951,0c0.669,0 1.212,-0.543 1.212,-1.212c-0,-2.746 -0,-9.414 -0,-12.159Z",
    style: {
      fill: "#94dadd"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M933.334,160.788l9.87,-4.166",
    style: {
      fill: "none",
      stroke: "#4eb2b7",
      strokeWidth: "2.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.097,158.308c0,0 -1.416,24.219 4.107,24.162",
    style: {
      fill: "none",
      stroke: "#4eb2b7",
      strokeWidth: "2.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.603,209.94c-0.673,-0.001 -1.293,-0.368 -1.617,-0.958c-2.147,-3.837 -5.027,-8.626 -5.027,-13.819c0,-5.193 2.88,-9.983 5.027,-13.819c0.324,-0.59 0.944,-0.956 1.617,-0.956c3.773,-0.001 16.272,-0.001 20.046,-0.001c0.673,0 1.292,0.367 1.616,0.957c2.147,3.836 5.027,8.626 5.027,13.819c0,5.193 -2.88,9.982 -5.026,13.82c-0.325,0.589 -0.944,0.956 -1.617,0.956c-3.774,0.001 -16.272,0.001 -20.046,0.001Z",
    style: {
      fill: "#4eb2b7"
    }
  }), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M930.603,209.94c-0.673,-0.001 -1.293,-0.368 -1.617,-0.958c-2.147,-3.837 -5.027,-8.626 -5.027,-13.819c0,-5.193 2.88,-9.983 5.027,-13.819c0.324,-0.59 0.944,-0.956 1.617,-0.956c3.773,-0.001 16.272,-0.001 20.046,-0.001c0.673,0 1.292,0.367 1.616,0.957c2.147,3.836 5.027,8.626 5.027,13.819c0,5.193 -2.88,9.982 -5.026,13.82c-0.325,0.589 -0.944,0.956 -1.617,0.956c-3.774,0.001 -16.272,0.001 -20.046,0.001Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M939.063,184.917c0,-0.669 -0.542,-1.212 -1.212,-1.212c-1.798,0 -5.153,0 -6.951,0c-0.669,0 -1.212,0.543 -1.212,1.212c0,2.746 0,9.414 0,12.159c0,0.67 0.543,1.212 1.212,1.212c1.798,0 5.153,0 6.951,0c0.67,0 1.212,-0.542 1.212,-1.212c0,-2.745 0,-9.413 0,-12.159Z",
    style: {
      fill: "#94dadd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.563,184.917c0,-0.669 -0.542,-1.212 -1.212,-1.212c-1.798,0 -5.153,0 -6.951,0c-0.669,0 -1.212,0.543 -1.212,1.212c0,2.746 0,9.414 0,12.159c0,0.67 0.543,1.212 1.212,1.212c1.798,0 5.153,0 6.951,0c0.67,0 1.212,-0.542 1.212,-1.212c0,-2.745 0,-9.413 0,-12.159Z",
    style: {
      fill: "#94dadd"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1095.83,102.455l9.87,-2.083",
    style: {
      fill: "none",
      stroke: "#4eb2b7",
      strokeWidth: "2.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101.6,102.058c0,0 -1.416,24.219 4.107,24.162",
    style: {
      fill: "none",
      stroke: "#4eb2b7",
      strokeWidth: "2.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.1,153.69c-0.673,-0.001 -1.293,-0.368 -1.617,-0.958c-2.147,-3.837 -5.027,-8.626 -5.027,-13.819c0,-5.193 2.88,-9.983 5.027,-13.819c0.324,-0.59 0.944,-0.956 1.617,-0.956c3.773,-0.001 16.272,-0.001 20.046,-0.001c0.673,0 1.292,0.367 1.616,0.957c2.147,3.836 5.027,8.626 5.027,13.819c0,5.193 -2.88,9.982 -5.026,13.82c-0.325,0.589 -0.944,0.956 -1.617,0.956c-3.774,0.001 -16.272,0.001 -20.046,0.001Z",
    style: {
      fill: "#4eb2b7"
    }
  }), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1093.1,153.69c-0.673,-0.001 -1.293,-0.368 -1.617,-0.958c-2.147,-3.837 -5.027,-8.626 -5.027,-13.819c0,-5.193 2.88,-9.983 5.027,-13.819c0.324,-0.59 0.944,-0.956 1.617,-0.956c3.773,-0.001 16.272,-0.001 20.046,-0.001c0.673,0 1.292,0.367 1.616,0.957c2.147,3.836 5.027,8.626 5.027,13.819c0,5.193 -2.88,9.982 -5.026,13.82c-0.325,0.589 -0.944,0.956 -1.617,0.956c-3.774,0.001 -16.272,0.001 -20.046,0.001Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1101.56,128.667c0,-0.669 -0.542,-1.212 -1.212,-1.212c-1.798,0 -5.153,0 -6.951,0c-0.669,0 -1.212,0.543 -1.212,1.212c0,2.746 0,9.414 0,12.159c0,0.67 0.543,1.212 1.212,1.212c1.798,0 5.153,0 6.951,0c0.67,0 1.212,-0.542 1.212,-1.212c0,-2.745 0,-9.413 0,-12.159Z",
    style: {
      fill: "#94dadd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1114.06,128.667c0,-0.669 -0.542,-1.212 -1.212,-1.212c-1.798,0 -5.153,0 -6.951,0c-0.669,0 -1.212,0.543 -1.212,1.212c0,2.746 0,9.414 0,12.159c0,0.67 0.543,1.212 1.212,1.212c1.798,0 5.153,0 6.951,0c0.67,0 1.212,-0.542 1.212,-1.212c0,-2.745 0,-9.413 0,-12.159Z",
    style: {
      fill: "#94dadd"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M836.459,293.057l-2.335,-94.414c-0.006,-0.818 -0.675,-1.477 -1.493,-1.471c-0.818,0.006 -1.477,0.675 -1.471,1.493l-0.951,94.438c0.013,1.725 1.423,3.115 3.148,3.102c1.725,-0.013 3.115,-1.423 3.102,-3.148Z",
    style: {
      fill: "#4eb2b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.11,177.814l-1.833,-86.511c-0.001,-0.818 -0.667,-1.481 -1.485,-1.479c-0.818,0.002 -1.48,0.668 -1.479,1.485l-1.453,86.519c0.004,1.724 1.407,3.122 3.132,3.118c1.725,-0.004 3.122,-1.407 3.118,-3.132Z",
    style: {
      fill: "#4eb2b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.69,196.491l-3.916,-88.556c-0.021,-0.818 -0.702,-1.465 -1.52,-1.444c-0.817,0.021 -1.464,0.702 -1.443,1.52l0.631,88.64c0.044,1.724 1.48,3.088 3.204,3.044c1.724,-0.044 3.088,-1.48 3.044,-3.204Z",
    style: {
      fill: "#4eb2b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.001,205.89l234.763,-94.712l87.112,-17.788",
    style: {
      fill: "none",
      stroke: "#4eb2b7",
      strokeWidth: "2.08px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "mountains-4",
    serifId: "mountains 4",
    d: "M3000,27.455c-0,0 -130.175,159.923 -305.655,163.501c-156.279,3.188 -277.006,-214.32 -427.679,-142.668c-113.336,53.897 -224.977,337.066 -462.502,342.392c-239.458,5.369 -475.017,-237.968 -667.708,-217.39c-152.636,16.301 -221.416,147.66 -482.29,118.486c-228.636,-25.569 -467.948,-300.944 -654.166,-258.888l-0.001,810.965l3000,0l-0,-816.398Z",
    style: {
      fill: "url(#_Linear15)",
      fillRule: "nonzero"
    }
  }), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3000,27.455c-0,0 -130.175,159.923 -305.655,163.501c-156.279,3.188 -277.006,-214.32 -427.679,-142.668c-113.336,53.897 -224.977,337.066 -462.502,342.392c-239.458,5.369 -475.017,-237.968 -667.708,-217.39c-152.636,16.301 -221.416,147.66 -482.29,118.486c-228.636,-25.569 -467.948,-300.944 -654.166,-258.888l-0.001,810.965l3000,0l-0,-816.398Z",
    clipRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2749.72,182.858c6.25,-1.991 9.609,-1.938 0.153,1.792c-28.132,11.096 -71.762,30.409 -54.624,39.868c19.61,10.824 33.91,27.321 0.606,40.244c-27.268,10.58 -72.678,-0.687 -108.196,16.551c-22.543,10.941 31.136,24.929 19.451,47.075c-11.369,21.548 -85.396,61.776 -126.052,72.168l-78.976,-15.174c85.001,-18.13 152.239,-38.382 170.475,-58.245c18.38,-20.019 -49.955,-37.528 1.998,-60.423c34.114,-15.034 88.944,1.368 119.64,-18.701c7.406,-4.841 -5.808,-13.146 -13.287,-19.328c-21.804,-18.023 31.529,-33.945 68.812,-45.827Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.132,283.129c5.299,-1.25 13.001,2.147 4.886,4.087c-22.736,5.437 -53.259,18.086 -41.105,27.935c11.617,9.413 28.338,19.317 10.098,27.163c-22.077,9.495 -52.596,10.352 -78.068,29.595c-16.167,12.213 19.399,25.337 14.1,41.147c-5.157,15.383 -61.609,42.964 -92.512,59.616l-66.643,12.003c65.283,-32.747 115.819,-49.552 126.839,-65.769c11.106,-16.344 -36.96,-33.478 -9.684,-54.041c24.254,-18.285 84.542,-25.025 86.912,-33.836c2.751,-10.229 -7.119,-10.687 -8.099,-18.049c-2.391,-17.968 35.793,-25.726 53.276,-29.851Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29.859,130.592c12.262,1.538 25.686,-0.578 36.012,-7.681c12.413,-8.539 22.959,-22.588 39.146,-23.565c8.806,-0.532 18.134,1.928 25.277,7.16c10.02,7.338 17.786,18.8 30.652,21.359c22.286,4.432 39.088,-20.161 60.593,-22.946c30.004,-3.886 56.653,32.468 86.038,17.1c5.412,-2.83 9.835,-7.098 14.051,-11.444c4.456,-4.593 8.769,-9.483 10.76,-15.696c2.083,-6.501 -10.293,-16.58 -13.873,-20.186c-18.78,-18.918 -41.835,-33.854 -65.478,-46.04c-18.138,-9.349 -37.162,-17.175 -57.109,-21.702c-23.173,-5.259 -47.359,-4.931 -70.955,-4.742c-12.33,0.099 -56.127,-2.742 -72.516,9.654c-28.453,21.522 -13.643,28.338 -7.856,113.891",
    style: {
      fill: "#fff",
      fillOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.15,226.227c14.672,-8.13 34.811,-11.816 50.416,-3.782c14.473,7.451 27.301,19.917 44.794,18.966c29.65,-1.611 50.077,-31.698 82.131,-30.434c38.552,1.521 66.459,38.967 102.963,49.072c37.543,10.393 52.15,-8.044 86.721,-11.469c23.279,-2.307 45.157,10.278 67.918,13.656c9.799,1.454 23.664,4.712 31.783,-3.097c11.394,-10.958 -14.408,-32.234 -20.824,-37.167c-32.585,-25.053 -78.109,-43.373 -116.439,-57.572c-111.558,-41.326 -229.422,-20.708 -324.831,48.767",
    style: {
      fill: "#fff",
      fillOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2176.74,110.746c13.823,-10.563 29.456,-18.184 47.197,-16.006c23.939,2.94 40.235,19.156 66.022,14.835c34.638,-5.804 51.08,-36.385 92.178,-30.468c34.209,4.925 85.923,49.491 113.57,6.439c5.689,-8.859 -8.416,-20.957 -14.048,-26.277c-23.48,-22.179 -47.896,-31.851 -78.547,-40.553c-71.338,-20.252 -148.35,10.06 -197.749,64.058",
    style: {
      fill: "#fff",
      fillOpacity: 0.6
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear15",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-2.08333,-1054.17,1054.17,-2.08333,1706.25,1081.62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#97c1fd",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8dcccc",
      stopOpacity: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer5Winter);
export default __webpack_public_path__ + "static/media/layer5-winter.d7ae86119627c89919416225d4752d23.svg";
export { ForwardRef as ReactComponent };